import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_COMP_COMPARE_FAILURE, FETCH_COMP_COMPARE_REQUEST, FETCH_COMP_COMPARE_SUCCESS, FETCH_COMPETITOR_FAILURE, FETCH_COMPETITOR_REQUEST, FETCH_COMPETITOR_SUCCESS } from "../actions/companyCompareActions";

  const initialState = {
    compCompareData: [],
    compCompareLoading: true,
    compCompareError: null,
    compCompetitorData: [],
    compCompetitorLoading: true,
    compCompetitorError: null,
  };
  
  const companyCompareReducers = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COMP_COMPARE_REQUEST:
        return { ...state, compCompareLoading: true , payload: action.payload};
      case FETCH_COMP_COMPARE_SUCCESS:
        return { ...state, compCompareLoading: false, compCompareData: action.payload };
      case FETCH_COMP_COMPARE_FAILURE:
        return { ...state, compCompareLoading: false, compCompareError: action.payload };
      case FETCH_COMPETITOR_REQUEST:
          return { ...state, compCompetitorLoading: true , payload: action.payload};
      case FETCH_COMPETITOR_SUCCESS:
          return { ...state, compCompetitorLoading: false, compCompetitorData: action.payload };
      case FETCH_COMPETITOR_FAILURE:
          return { ...state, compCompetitorLoading: false, compCompetitorError: action.payload };  
      case RESET_ALL_ACCOUNT_STATE_DEPEN:{
         return { ...state, compCompareLoading: false , compCompetitorLoading: false ,compCompetitorData: [], compCompareData: [],};  
      }    
      default:
        return state;
    }
  };
  
  export default companyCompareReducers;
  